import axios from 'axios'

const state = {
	judges: {
		results: []
	},
	activeOrdering: '',
	activeLetter: '',
	countries: [],
	activeCountries: [],
	activeCode: [],
	name: [],
	activeName: ''
}

const getters = {
	isCountryActive (state) {
		return item => state.activeCountries.some(country => country === item)
	},
	isOrderingActive (state) {
		return item => state.activeOrdering === item
	},
	isLetterActive (state) {
		return item => state.activeLetter === item
	},
	isNameActive (state) {
		return item => state.activeName === item
	},
	isAnyJudgesFilterSelected (state) {
		return state.activeCountries[0] ||
			state.activeName ||
			state.activeLetter
	}
}

const mutations = {
	setJudges (state, judges) {
		state.judges = judges
	},
	setCountries (state, country) {
		state.countries = country
	},
	addCountry (state, item) {
		state.activeCountries.push(item)
		state.activeCode.push(item.code)
	},
	removeCountry (state, item) {
		state.activeCountries = state.activeCountries.filter(country => country !== item)
		state.activeCode = state.activeCode.filter(code => code !== item.code)
	},
	setNames (state, name) {
		state.name = name
	},
	addName (state, name) {
		state.activeName = name
	},
	removeName (state) {
		state.activeName = ''
	},
	editFilters (state, filter) {
		state[filter.type] = filter
	},
	addLetter (state, letter) {
		state.activeLetter = letter
	},
	removeLetter (state) {
		state.activeLetter = ''
	},
	addOrdering (state, order) {
		state.activeOrdering = order
	},
	removeOrdering (state) {
		state.activeOrdering = ''
	}
}

const actions = {
	fetchJudges ({ commit, state }, index) {
		const qs = require('qs')
		const config = {
			params: {
				ordering: state.activeOrdering,
				first_letter: state.activeLetter,
				name: state.activeName,
				nationality: state.activeCode,
				page: index
			},
			paramsSerializer (params) {
				return qs.stringify(params, {indices: false})
			}
		}

		axios.get('/api/judges/', config)
			.then(response => {
				const judges = { ...response.data, currentPage: index || 1 }

				if (state.activeOrdering === '-average_score') { // fix order by score - no-rating to the end
					const noScoreResults = judges.results.filter(result => result.average_score === null)
					const withScoreResults = judges.results.filter(result => result.average_score !== null)
					judges.results = [...withScoreResults, ...noScoreResults]
				}

				commit('setJudges', judges)
			})
			.catch(error => {
				console.error(error)
			})
	},
	fetchJudgeCountries ({ commit }) {
		// const params = {}
		axios.get('/api/places/countries/autocomplete/', {
		})
			.then(response => {
				const countries = response.data
				commit('setCountries', countries)
			})
			.catch(error => {
				console.error(error)
			})
	},
	fetchNames ({ commit }) {
		// const params = {}
		axios.get('/api/judges/autocomplete/', {
		})
			.then(response => {
				const name = response.data
				commit('setNames', name)
			})
			.catch(error => {
				console.error(error)
			})
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/judges.js